$(document).ready(function () {
    $('.course-list-item-show-dates').on('click', function (e) {
        var content = $(this).parent().next('.course-list-item-content');
        content.toggleClass('open');
       
        if($(this).hasClass('open')){
            $(this).html("Show dates").removeClass('open');
           
        } else{
            $(this).html("Hide dates").addClass('open');
        }
    })

    $('.course-date-list-item .show-more').on('click', function (e) {
        e.preventDefault();
        $(this).remove();
        $('.course-date-list-item').each(function(){
            $(this).removeClass('hidden');
        });
    })

    $('.course-list-item').each(function () {
        var $content = $(this).find('.course-list-item-content');
        if (!$content.length) {
            $(this).find('.course-list-item-show-dates').addClass('hide');
        }
    })
})